import React, { useEffect, useState } from "react";
import { useSessionStore } from "../../../../../Stores/SessionStore";
import BusyIndicator from "../../../../Core/BusyIndicator";
import ServiceCategoryCard from "./ServiceCategoryCard";

export default function ServiceGrid(props) {
	const store = useSessionStore();
	const [products, setProducts] = useState(null);

	useEffect(() => {
		async function getProducts() {
			const results = await store.ProductsService.GetProducts();
			if (results && results.Success) {
				setProducts(results.Data);
			}
		}

		getProducts();
	}, [store]);

	function getProductCategories() {
		const categories = [];

		if (products) {
			for (let i = 0; i < products.length; i++) {
				const category = categories.find((p) => p.Category === products[i].Category);

				if (category) {
					category.Products.push(products[i]);
				} else {
					categories.push({ Category: products[i].Category, Products: [products[i]] });
				}
			}
		}

		for (let i = 0; i < categories.length; i++) {
			categories[i].Products = categories[i].Products.sort((a, b) => a.Price - b.Price);
		}

		try {
			categories.sort((a, b) => parseInt(a.Category.split(" ")[0], 10) - parseInt(b.Category.split(" ")[0], 10));
		} catch (e) {
			// ignore sort failures for unexpected category labels
		}

		return categories;
	}

	const categories = getProductCategories();

	return (
		<React.Fragment>
			{products && (
				<React.Fragment>
					<p className="text-center mb-4">Please select from the following available packages</p>
					<div className="d-flex flex-column" style={{ gap: "24px" }}>
						{categories.map((category) => (
							<ServiceCategoryCard
								key={category.Category}
								category={category}
								onProductClick={props.onServiceClicked}
							/>
						))}
					</div>
				</React.Fragment>
			)}
			<BusyIndicator show={products === null} />
		</React.Fragment>
	);
}
